var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-insure-info',{staticClass:"pt-insure-info__withData",attrs:{"exportLoading":_vm.exportLoading},on:{"exportInsureMaterials":_vm.exportInsureMaterials}})}
var staticRenderFns = []

export { render, staticRenderFns }